


import { modelValid } from "../../../Models/modelSystemG";
import { panelController } from "../../../stores/service";


export class AlertaService {
  user = "";
  documentUser = [];
  index = -1;
  blockData = []
  listdata =[]

  constructor(documentUser, user) {
    this.documentUser = JSON.parse(JSON.stringify(documentUser));
    this.user = user;
    this.index = this.documentUser.findIndex(
      (users) => users.email === this.user
    );
  }

  listAllDevices() {
    this.listdata =[];
    this.blockData = [];
    this.documentUser.forEach((element,indexUser) => {
      
      if (element.hasOwnProperty("notificaciones")) {
        
        if (element.notificaciones.length == 0) {
          return false
        }

        for (let [indexDevices, notfi] of this.documentUser[indexUser].notificaciones.entries()) {
          
          this.blockData.push(notfi);
          this.listdata.push({
            name:this.documentUser[indexUser].name,
            indexUser:indexUser,
            indexDevices:indexDevices

          })
        }

      }
      
    });
    
    
    
    return this.blockData.length > 0 ? this.blockData :  false
  }



  async deleteRecord(index){

    this.documentUser[this.listdata[index].indexUser].notificaciones.splice(index, 1)

    return await this.act(JSON.parse(JSON.stringify(this.documentUser)));
   
  /*   panelController.update((service) => {
            service.service.tableadmins = documentUser;
            return service;

        }); */
  }

  async act(documentUser) {
        panelController.update((service) => {
            service.service.tableadmins = documentUser;
            return service;

        });
        let update = await modelValid({
            doc: 'updateDoc'
        });


        return true;
    }
  

}
